"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _WalletCardContainer = _interopRequireDefault(require("./WalletCardContainer"));
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
require("./WalletCardGrid.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var walletCardGridClasses = (0, _cssClassesHelper.getBEMClasses)('wallet-card-grid');
var WalletCardGrid = function WalletCardGrid(props) {
  var items = props.products.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_WalletCardContainer["default"], {
      key: item.ProductId,
      productId: item.ProductId,
      detailsLink: props.detailsLink
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.fetching || !!items.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: walletCardGridClasses()
  }, props.fetching ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null) : items) : '');
};
var _default = exports["default"] = WalletCardGrid;